import {
  AccordionContent,
  AccordionHeading,
  Text,
} from '@moonpig/launchpad-components'
import React from 'react'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { AccordionSections } from '../types'

export const UnboxingInformationModule = ({
  isLetterboxProduct = false,
}: {
  isLetterboxProduct?: boolean
}) => {
  const localiseText = useCoreLocaleText()
  const UnboxingInformationCopy = isLetterboxProduct
    ? localiseText('common.unboxing_information_letterbox_copy')
    : localiseText('common.unboxing_information_standard_copy')

  return (
    <AccordionContent
      heading={
        <AccordionHeading level="h2">
          {localiseText('common.unboxing_information')}
        </AccordionHeading>
      }
      value={AccordionSections.UnboxingInformation}
    >
      <Text>{UnboxingInformationCopy}</Text>
    </AccordionContent>
  )
}
